import { useEffect as e } from "react";
import { useHistory as t, useLocation as n } from "react-router-dom";
//#region src/ScrollToTop.tsx
var r = () => {
	let { pathname: r, hash: i } = n(), a = t();
	return e(() => {
		a.action !== "POP" && (i || window.scrollTo(0, 0));
	}, [r]), null;
};
//#endregion
export { r as ScrollToTop };
